// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderTitle":"c-n_fQ"};